import lodash from "lodash";
import notifiers from "../global/constants/NotificationConstants";
import strings from "../global/constants/StringConstants";
import urls from "../global/constants/UrlConstants";
import { BillItem, PayPageSessionResponse, Price } from "../models/interfaces";
import { ItemObject } from "../models/ItemObject";
import { addIdemp, addItems, addSession } from "../redux/menuSlice";
import { validateItemsAndModifiers } from "../screens/Cart/CartService";
import { GUID, OrderedItem } from "../socketType";
import { globalEmitter } from "../utils/emitter";
import history from "../utils/history";
import { store } from "../utils/store";
import { v4 as uuidv4 } from "uuid";

const methodsContext = this;

export const isTruthy = (value: any, shouldCheckByType: boolean = true) => {
  const validatedByType = shouldCheckByType
    ? customValidatorByType(value)
    : true;

  if (value !== null && value !== undefined && validatedByType) {
    return true;
  }
  return false;
};

const customValidatorByType = (value: any) => {
  if (value !== undefined && value !== null) {
    const type = typeof value;
    switch (type) {
      case "string":
        return value.trim() !== "";
      case "object":
        if (Array.isArray(value)) {
          return value.length > 0;
        } else {
          return Object.keys(value).length > 0;
        }
      default:
        return true;
    }
  }
};

export const compareStrings = (string1: string, string2: string) => {
  if (!(isTruthy(string1) || isTruthy(string2))) {
    return true;
  } else {
    if (string1 && string2) {
      if (string1.toLowerCase() === string2.toLowerCase()) {
        return true;
      }
    }
  }
  return false;
};

export const openInfoNotification = (message: any, title: string = "Info") => {
  globalEmitter.emit(strings.notification, {
    type: strings.info,
    message: message,
    title: title,
  });
};

export const openSuccessNotification = (
  message: any,
  title: string = "Success"
) => {
  globalEmitter.emit(strings.notification, {
    type: strings.success,
    message: message,
    title: title,
  });
};

export const openWarningNotification = (
  message: any,
  title: string = "Warning"
) => {
  globalEmitter.emit(strings.notification, {
    type: strings.warning,
    message: message,
    title: title,
  });
};

export const openErrorNotification = (
  message: any,
  title: string = "Error"
) => {
  globalEmitter.emit(strings.notification, {
    type: strings.error,
    message: message,
    title: title,
  });
};

export const convertPriceToDollarFormat = (value: number) => {
  return `$${(value / 100).toFixed(2)}`;
};

export const convertPriceToReadableFormat = (value: number) => {
  return `${(value / 100).toFixed(2)}`;
};

export function debounce(func: Function, wait: number) {
  let timeout: any;
  return function (...args: any) {
    const context = methodsContext;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export function debounceEventHandler(func: Function, wait: number) {
  const debounced = debounce(func, wait);
  return function (event: any) {
    event.persist();
    return debounced(event);
  };
}

export const getCartTotal = () => {
  return store.getState().menu.addedItems?.reduce((acc: number, val: any) => {
    return acc + val.calculatedTotal;
  }, 0);
};

export const convertPricesToItems = (prices: Price[]) => {
  return prices.map((price: any) => {
    let p: Price[] = [];
    p.push(price);
    return new ItemObject(
      price.id,
      price.posId,
      price.name,
      price.name,
      p,
      [],
      [],
      false,
      "",
      "",
      undefined,
      1,
      ""
    );
  });
};

export const getFormattedNumbers = (value: string) => {
  const matches = value.match(/\d+/g);
  let number = "";
  if (matches !== null) {
    matches.forEach((match) => {
      number = number + match;
    });
  }
  if (number.length === 10) {
    value = number.replace(/^(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  }
  return { number: number, maskedNumber: value };
};

export const getBillItemsArray = (...args: BillItem[]) => {
  let billItems: BillItem[] = [];
  const totalIndex = args.findIndex((billItem) => billItem.text === "Total");
  const isTotalPresent = totalIndex !== -1;
  const totalObject = isTotalPresent ? args.splice(totalIndex, 1)[0] : null;
  if (isTotalPresent && totalObject) {
    args.push(totalObject);
  }
  billItems.push(...args);
  return billItems;
};

export const formatBillItem = (text: string, label: string, value: number) => {
  return {
    text: text,
    label: label,
    value: value,
  };
};

export const getCurrentStage = (stage: number) => {
  let options = ["", "drinks", "appetizers", "entrees", "desserts"];
  return { stageNum: stage, tag: options[stage] };
};

export const validateBeforePlacingOrder = async (
  // name: string,
  // mobileNumber: string,
  tableNum: string,
  validateItemsAndModifiers: boolean
) => {
  let continueExecution = true;
  if (!urls.DEMO) {
    if (validateItemsAndModifiers) {
      continueExecution = await validateItemsAndModifiersBeforePlaceOrder();
    }
    if (continueExecution) {
      // if (!isTruthy(name) && !isTruthy(mobileNumber)) {
      //   openWarningNotification(notifiers.ENTER_NAME_AND_CONTACT_NUMBER_ERROR);
      //   return false;
      // }
      // if (!isTruthy(name)) {
      //   openWarningNotification(notifiers.ENTER_NAME_ERROR);
      //   return false;
      // }
      // if (!isTruthy(mobileNumber) || mobileNumber.length !== 10) {
      //   openWarningNotification(notifiers.ENTER_CONTACT_NUMBER_ERROR);
      //   return false;
      // }
      if (!isTruthy(tableNum)) {
        openErrorNotification(notifiers.EMPTY_TABLE_NUM_ERROR);
        return false;
      }
    }
    // store.dispatch(
    //   addUserDetails({
    //     name: name,
    //     mobile: mobileNumber,
    //   })
    // );
  }
  return true;
};

export const validateItemsAndModifiersBeforePlaceOrder = async () => {
  try {
    const itemsToRemoveIds = await validateItemsAndModifiers();
    if (isTruthy(itemsToRemoveIds)) {
      removeOutOfStockItem(itemsToRemoveIds);
      return false;
    } else {
      return true;
    }
  } catch (error: any) {
    openErrorNotification(
      isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
    );
    return false;
  }
};

const removeOutOfStockItem = (itemsToRemoveIds: any) => {
  let addedItemsArray = lodash.cloneDeep(store.getState().menu.addedItems);
  let itemsToRemoveNames: string[] = [];
  let modifiersOutOfStock = false;
  for (const guid in itemsToRemoveIds) {
    if (isTruthy(itemsToRemoveIds[guid])) {
      modifiersOutOfStock = true;
    } else {
      addedItemsArray = addedItemsArray.filter((item: any) => {
        if (item.guid !== guid) return item;
        else itemsToRemoveNames.push(item.name);
      });
    }
  }
  store.dispatch(addItems(addedItemsArray));
  if (modifiersOutOfStock) {
    history.push(urls.cartViewPath);
  }
  if (itemsToRemoveNames.length > 0)
    openWarningNotification(
      notifiers.getAutoRemoveOutOfStockItemMessage(itemsToRemoveNames)
    );
};

export const getUserInitials = (username: string) => {
  if (!isTruthy(username)) return;
  const names = username.split(" ");
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
};

export const hashSessionId = (sessionId: string) => {
  const seed = 0;
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < sessionId.length; i++) {
    ch = sessionId.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 =
    Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
    Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 =
    Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
    Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

export const getUserColor = (sessionId: string) => {
  if (!sessionId) {
    return "#f4f4f4";
  }
  const hash = hashSessionId(sessionId);
  const color = hash % strings.userAvatarColors.length;
  return strings.userAvatarColors[color];
};

export const getInputMaskNumber = (value: string) => {
  if (value === undefined || value === null) return "";
  const matches = value.match(/\d+/g);
  let number = "";
  if (matches !== null) {
    matches.forEach((match) => {
      number = number + match;
    });
  }
  return number;
};

export const getMaskLength = (value: string) => {
  return value.replace(/\s/g, "").length;
};

export const updateSessionItemsAndWaiterAddedBasedOnGuids = (
  state: GUID[],
  forRefund: boolean
) => {
  let currentSession = lodash.cloneDeep(store.getState().menu.session);
  const sessionItems = currentSession.sessionItems;
  const waiterAddedItems = currentSession.waiterAdded;
  Object.keys(sessionItems).forEach((sessionId: string) => {
    Object.keys(sessionItems[sessionId].orders).forEach((orderId: string) => {
      sessionItems[sessionId].orders[orderId].forEach((item) => {
        if (item.guid && state.includes(item.guid)) {
          if (forRefund) {
            item.refund = true;
          } else {
            item.paid = true;
          }
        }
      });
    });
  });
  const updatedWaiterAddedItems = waiterAddedItems.map((item) => {
    if (item.guid && state.includes(item.guid)) {
      if (forRefund) {
        return {
          ...item,
          refund: true,
        };
      } else {
        return {
          ...item,
          paid: true,
        };
      }
    }
    return item;
  });
  currentSession.waiterAdded = updatedWaiterAddedItems;
  currentSession.sessionItems = sessionItems;
  store.dispatch(addSession(currentSession));
};

export const fetchSplitPayUserSelectedItems = (
  session: PayPageSessionResponse,
  sessionId: string
) => {
  const orders: Partial<OrderedItem>[] = [];
  if (Object.keys(session.sessionItems).length) {
    Object.keys(session.sessionItems).forEach((sessionId: string) => {
      Object.keys(session.sessionItems[sessionId]).length &&
        Object.keys(session.sessionItems[sessionId].orders).forEach(
          (orderId: string) => {
            session.sessionItems[sessionId].orders[orderId].forEach(
              (orderedItem: any) => {
                if (
                  Object.keys(session.splitPayState).includes(
                    orderedItem.guid
                  ) &&
                  sessionId ===
                    session.splitPayState[orderedItem.guid].sessionId
                ) {
                  orders.push(orderedItem);
                }
              }
            );
          }
        );
    });
  }
  session.waiterAdded.forEach((orderedItem: any) => {
    if (
      Object.keys(session.splitPayState).includes(orderedItem.guid) &&
      sessionId === session.splitPayState[orderedItem.guid].sessionId
    ) {
      orders.push(orderedItem);
    }
  });
  return orders;
};

export const validateEmail = (email: string) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

export const requiresLocalStorageClear = () => {
  const hardReloadFlag = store.getState().general.hardReloadFlag;
  if (
    !isTruthy(hardReloadFlag) ||
    (isTruthy(hardReloadFlag) && hardReloadFlag !== "idemp-release")
  ) {
    console.info("Clearing local storage...");
    localStorage.clear();
    return true;
  }
  return false;
};

export const processIdemp = (mode: string, paymentHash?: string) => {
  const existingIdemp = store.getState().menu.idemp;
  const hash = generateHashForIdemp(mode, paymentHash);
  let idempotencyKey = existingIdemp?.key ?? "";
  if (!isTruthy(idempotencyKey) || !compareStrings(existingIdemp.hash, hash)) {
    store.dispatch(
      addIdemp({
        mode,
        key: uuidv4(),
        hash,
      })
    );
  }
};

export const generateHashForIdemp = (mode: string, paymentHash?: any) => {
  const sessionId = store.getState().menu.sessionId;
  const session = store.getState().menu.session;
  const addedItems = fetchSplitPayUserSelectedItems(session, sessionId);
  const tip = store.getState().menu.tip;
  switch (mode) {
    case "adoptacard": {
      const hashCombination = { addedItems, tip };
      return generateStringHash(JSON.stringify(hashCombination));
    }
    case "pay": {
      const hashCombination = { addedItems, tip, paymentHash };
      return generateStringHash(JSON.stringify(hashCombination));
    }
    default: {
      const hashCombination = { addedItems, tip, paymentHash };
      return generateStringHash(JSON.stringify(hashCombination));
    }
  }
};

export const generateStringHash = (input: string) => {
  let hash = 0;

  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char;
  }
  const hashString = (hash >>> 0).toString(16);
  return hashString;
};

export const getCheckoutButtonText = () => {
  return store.getState().general.checkoutState.buttonText;
};

export const getCheckoutErrorIn = () => {
  return store.getState().general.checkoutState.errorIn;
};

export const emitSocketEvent = (event: string, params: any = "undefined") => {
  globalEmitter.emit(strings.socketEmit, {
    type: strings.socketEmit,
    event,
    params,
  });
};
